import React from 'react'
import styled from 'styled-components'
import { FullBillFragment, MerchantSummaryFragment } from '../../../graphql/generated/graphql'

const Circle = styled.div<{ $size: number }>`
    background: #d6d6d6;
    border-radius: 50%;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
`

const CircleImage = styled.img<{ $size: number }>`
    background: transparent;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    object-fit: contain;
`

export const InstitutionImage: React.VFC<{
    institution: FullBillFragment['institution']
    size?: number
}> = ({ institution, size = 30 }) => {
    const hasImage = institution?.logo || institution?.logoUrl
    const src = institution?.logo
        ? `data:image/png;base64,${institution?.logo}`
        : institution?.logoUrl ?? ''
    return <>{hasImage ? <CircleImage src={src} $size={size} /> : <Circle $size={size} />}</>
}

export const MerchantImage: React.VFC<{
    merchant: MerchantSummaryFragment
    size?: number
}> = ({ merchant, size = 30 }) => {
    return (
        <>
            {merchant?.logo ? (
                <CircleImage src={merchant.logo} $size={size} />
            ) : (
                <Circle $size={size} />
            )}
        </>
    )
}

export const CircleLogo: React.VFC<{
    logoUrl?: string | null
    size?: number
}> = ({ logoUrl, size = 30 }) => {
    return <>{logoUrl ? <CircleImage src={logoUrl} $size={size} /> : <Circle $size={size} />}</>
}
